<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2023-04-08 17:17:13
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2023-06-21 10:24:12
 * @FilePath: \NCCEE2\src\views\Manger\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="bodyBox">
    <div class="silder-box">
      <el-menu
        default-active="1"
        class="el-menu-vertical-demo"
        background-color="#32709F"
        text-color="#fff"
        active-text-color="#409EFF"
        :router="true"
      >
        <el-menu-item index="1" route="gdp">
          <i class="el-icon-menu"></i>
          <span slot="title">人口与GDP</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="main-box">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.bodyBox {
  height: 100%;
  width: 100%;
  /* background-color: aqua; */
  display: flex;
}
.silder-box {
  width: 10%;
  height: 100%;
  background-color: #32709f;
}
.main-box {
  /* background-color: rgb(62, 9, 154); */
  width: 90%;
  height: 100%;
}
</style>